import axios from "axios";
import config from '../config/index';

export default class Project {
  static instance = axios.create({
    baseURL: config.backendUri + '/api',
    headers:{
      Authorization:'Bearer ' + localStorage.getItem('token')
    }
  });

  static instanceConfig () {
    this.instance.interceptors.request.use(configH => {
      const token = localStorage.getItem('token');
      configH.headers.Authorization = `Bearer ${token}`;
      return configH;
    });
  }


  static async getAllUserTasksGlobally (_id) {
    this.instanceConfig();
    const resp = await (await this.instance.post('notifications_tasks', {_id})).data;
    return resp;
  }


}
